const landing = {
  en: {
    landing: {
      nav: {
        demo: 'Demo',
        features: 'Features',
        howItWorks: 'How it Works',
        efficiency: 'Efficiency',
        pricing: 'Pricing',
        signIn: 'Sign In',
        joinFree: 'Join for Free',
        getStarted: 'Get Started',
      },
      hero: {
        badgeIntelligenceBy: 'Intelligence by',
        headlineLine1: 'Break language barriers',
        headlineLine2: 'with zero friction.',
        subheadline:
          'A premium workspace designed for professionals to seamlessly translate, organize, and reference multi-lingual content in real-time.',
        joinFree: 'Join Free',
        pricing: 'Pricing',
        aiWorkspace: 'AI Workspace',
        refined: 'Refined',
        translating: 'Translating...',
      },
      features: {
        headingBefore: 'Everything you need to work',
        headingHighlight: 'globally.',
        subheading:
          'A suite of powerful tools designed specifically to optimize your multilingual workflow.',
        feature1Title: 'Lightning Fast Translation',
        feature1Desc:
          'Powered by advanced AI models, get real-time translations across dozens of languages with native-like accuracy.',
        feature2Title: 'Smart Smartbook',
        feature2Desc:
          'Save important words and full translations to your personal notebook. Organize by custom tags and access them instantly.',
        feature3Title: 'Contextual History',
        feature3Desc:
          'Never lose a translation. Your entire workflow is automatically saved with contextual metadata for easy retrieval.',
        feature4Title: 'Privacy First Workspace',
        feature4Desc:
          'Your data is encrypted and secure. We focus on providing a private, secure environment for your intellectual property.',
      },
      stats: {
        stat1Value: '50+',
        stat1Label: 'Languages Supported',
        stat2Value: 'Real-time',
        stat2Label: 'Instant Translation',
        stat3Value: '99.9%',
        stat3Label: 'Uptime Guarantee',
        stat4Value: 'Encrypted',
        stat4Label: 'Data Security',
      },
      howItWorks: {
        headingBefore: 'How it',
        headingHighlight: 'works.',
        subheading: 'Get started in seconds. No configuration required.',
        step1Title: 'Type or Paste',
        step1Desc:
          'Enter any text in any language. Our AI automatically detects the source language for you.',
        step2Title: 'AI Translates Instantly',
        step2Desc:
          'Advanced AI models process your text in real-time and deliver accurate, context-aware translations.',
        step3Title: 'Save & Organize',
        step3Desc:
          'Bookmark words, save translations to your history, and write notes — your personal language workspace.',
      },
      demo: {
        badge: 'Intelligence by GEMINI',
        headingBefore: 'Translation that understands',
        headingHighlight: 'context.',
        subheadingPart1: 'Standard translators give you words. We give you the right',
        subheadingTone: 'tone',
        subheadingPart2: 'for every situation.',
        selectLanguage: 'Select Language',
        selectLanguageDesc: 'See how nuances change across languages.',
        adjustTone: 'Adjust Tone',
        adjustToneDesc: 'Switch between politeness levels.',
        bestFor: 'Best for',
        standard: 'Standard',
        aiWorkbench: 'AI Workbench',
        input: 'Input',
        refined: 'Refined',
        lang: {
          japanese: 'Japanese',
          thai: 'Thai',
        },
        tone: {
          casual: 'Casual',
          business: 'Business',
          honorific: 'Honorific',
          formal: 'Formal',
        },
        context: {
          friendsFamily: 'Friends or family',
          coworkersClients: 'Co-workers or clients',
          superiorFormal: 'Superior or formal proposal',
          closeColleagues: 'Close colleagues',
          professionalSetting: 'Professional setting',
          officialCorrespondence: 'Official correspondence',
        },
      },
      pricing: {
        heading: 'Simple, transparent pricing.',
        subheading: 'Start for free, upgrade when you need more power. No hidden fees.',
        perMonth: '/ mo',
        starterName: 'Starter',
        starterDesc: 'Perfect for trying out the platform.',
        starterFeature1: '5,000 tokens / mo',
        starterFeature2: '3 Notes',
        starterFeature3: '10 Words',
        starterFeature4: 'History access',
        getStarted: 'Get Started',
        proName: 'Pro',
        proDesc: 'For professionals needing power.',
        popular: 'Popular',
        proFeature1: '50,000 tokens / mo',
        proFeature2: 'Unlimited Notes',
        proFeature3: 'Unlimited Saved',
        proFeature4: 'Priority support',
        proTrial: 'Pro Trial',
      },
      cta: {
        heading: 'Ready to break language barriers?',
        subheading:
          'Join thousands of professionals using AI Workbench to communicate seamlessly across languages.',
        button: 'Get Started Free',
      },
      footer: {
        tagline:
          'Next-generation translation tools designed for professionals. Break language barriers with zero friction.',
        quickLinks: 'Quick Links',
        features: 'Features',
        pricing: 'Pricing',
        rightsReserved: 'All rights reserved.',
        poweredBy: 'Powered by',
      },
      pricingPage: {
        backToWorkspace: 'Back to Workspace',
        badge: 'Simple Transparent Pricing',
        headingLine1: 'Choose the plan that',
        headingLine2: 'fits your workflow.',
        subheading:
          'Unlock the full power of context-aware AI translation and professional organization tools.',
        perMonth: '/month',
        mostPopular: 'Most Popular',
        freeName: 'Free',
        freeDesc: 'Perfect for individual explorers.',
        freeFeature1: '1,000 Tokens / month',
        freeFeature2: 'Last 10 history items',
        freeFeature3: 'Standard AI models',
        freeFeature4: 'Basic Notebook (5 notes)',
        freeFeature5: 'Personal usage only',
        freeCta: 'Current Plan',
        proName: 'Pro',
        proDesc: 'Best for power users and professionals.',
        proFeature1: 'Unlimited Tokens',
        proFeature2: 'Full Translation History',
        proFeature3: 'Priority AI Models (GPT-4o/Claude)',
        proFeature4: 'Unlimited Notebook & Tags',
        proFeature5: 'Tone & Style Control',
        proFeature6: 'Save up to 1,000 words',
        proCta: 'Upgrade to Pro',
        businessName: 'Business',
        businessDesc: 'Advanced features for teams.',
        businessFeature1: 'Everything in Pro',
        businessFeature2: 'Multi-user Collaboration',
        businessFeature3: 'API Access (Beta)',
        businessFeature4: 'Custom Terminology Base',
        businessFeature5: 'Dedicated Support',
        businessFeature6: 'Privacy-First Data Isolation',
        businessCta: 'Contact Sales',
        trustedBy: 'Trusted by Professionals Globally',
        trustSsl: 'SSL Encrypted',
        trustPrivacy: 'Local Privacy',
        trustAward: 'Award Winning',
        trustRating: '4.9/5 Rating',
      },
    },
  },
  th: {
    landing: {
      nav: {
        demo: 'เดโม',
        features: 'ฟีเจอร์',
        howItWorks: 'วิธีใช้งาน',
        efficiency: 'ประสิทธิภาพ',
        pricing: 'ราคา',
        signIn: 'เข้าสู่ระบบ',
        joinFree: 'เข้าร่วมฟรี',
        getStarted: 'เริ่มต้นใช้งาน',
      },
      hero: {
        badgeIntelligenceBy: 'ขับเคลื่อนโดย',
        headlineLine1: 'ทลายกำแพงภาษา',
        headlineLine2: 'อย่างไร้รอยต่อ',
        subheadline:
          'พื้นที่ทำงานระดับพรีเมียมสำหรับมืออาชีพ แปล จัดระเบียบ และอ้างอิงเนื้อหาหลายภาษาได้แบบเรียลไทม์',
        joinFree: 'เริ่มฟรี',
        pricing: 'ราคา',
        aiWorkspace: 'พื้นที่ทำงาน AI',
        refined: 'ปรับแล้ว',
        translating: 'กำลังแปล...',
      },
      features: {
        headingBefore: 'ทุกสิ่งที่คุณต้องการเพื่อทำงาน',
        headingHighlight: 'ระดับโลก',
        subheading: 'ชุดเครื่องมือทรงพลังที่ออกแบบมาเพื่อเพิ่มประสิทธิภาพการทำงานหลายภาษาของคุณโดยเฉพาะ',
        feature1Title: 'แปลเร็วดั่งสายฟ้า',
        feature1Desc:
          'ขับเคลื่อนด้วยโมเดล AI ขั้นสูง แปลภาษาแบบเรียลไทม์ได้หลายสิบภาษาด้วยความแม่นยำระดับเจ้าของภาษา',
        feature2Title: 'สมุดบันทึกอัจฉริยะ',
        feature2Desc:
          'บันทึกคำสำคัญและคำแปลทั้งหมดลงในสมุดบันทึกส่วนตัว จัดระเบียบด้วยแท็กที่กำหนดเองและเรียกดูได้ทันที',
        feature3Title: 'ประวัติตามบริบท',
        feature3Desc:
          'ไม่มีวันสูญเสียคำแปล ทุกการทำงานถูกบันทึกอัตโนมัติพร้อมข้อมูลบริบทเพื่อการเรียกดูที่ง่ายดาย',
        feature4Title: 'พื้นที่ทำงานที่เน้นความเป็นส่วนตัว',
        feature4Desc:
          'ข้อมูลของคุณถูกเข้ารหัสและปลอดภัย เรามุ่งมั่นมอบสภาพแวดล้อมที่เป็นส่วนตัวและปลอดภัยสำหรับทรัพย์สินทางปัญญาของคุณ',
      },
      stats: {
        stat1Value: '50+',
        stat1Label: 'ภาษาที่รองรับ',
        stat2Value: 'เรียลไทม์',
        stat2Label: 'แปลทันที',
        stat3Value: '99.9%',
        stat3Label: 'การันตี Uptime',
        stat4Value: 'เข้ารหัส',
        stat4Label: 'ความปลอดภัยข้อมูล',
      },
      howItWorks: {
        headingBefore: 'วิธีการ',
        headingHighlight: 'ทำงาน',
        subheading: 'เริ่มต้นได้ในไม่กี่วินาที ไม่ต้องตั้งค่าใดๆ',
        step1Title: 'พิมพ์หรือวาง',
        step1Desc: 'ป้อนข้อความภาษาใดก็ได้ AI ของเราจะตรวจจับภาษาต้นทางให้คุณโดยอัตโนมัติ',
        step2Title: 'AI แปลทันที',
        step2Desc: 'โมเดล AI ขั้นสูงประมวลผลข้อความของคุณแบบเรียลไทม์ และมอบคำแปลที่แม่นยำและเข้าใจบริบท',
        step3Title: 'บันทึกและจัดระเบียบ',
        step3Desc:
          'บุ๊กมาร์กคำศัพท์ บันทึกคำแปลลงประวัติ และจดโน้ต — พื้นที่ทำงานด้านภาษาส่วนตัวของคุณ',
      },
      demo: {
        badge: 'ขับเคลื่อนโดย GEMINI',
        headingBefore: 'การแปลที่เข้าใจ',
        headingHighlight: 'บริบท',
        subheadingPart1: 'นักแปลทั่วไปให้คุณแค่คำ เราให้',
        subheadingTone: 'โทน',
        subheadingPart2: 'ที่ถูกต้องสำหรับทุกสถานการณ์',
        selectLanguage: 'เลือกภาษา',
        selectLanguageDesc: 'ดูว่าความละเอียดอ่อนเปลี่ยนไปอย่างไรในแต่ละภาษา',
        adjustTone: 'ปรับโทน',
        adjustToneDesc: 'สลับระหว่างระดับความสุภาพ',
        bestFor: 'เหมาะสำหรับ',
        standard: 'ทั่วไป',
        aiWorkbench: 'AI Workbench',
        input: 'อินพุต',
        refined: 'ปรับแล้ว',
        lang: {
          japanese: 'ญี่ปุ่น',
          thai: 'ไทย',
        },
        tone: {
          casual: 'กันเอง',
          business: 'ธุรกิจ',
          honorific: 'ยกย่อง',
          formal: 'ทางการ',
        },
        context: {
          friendsFamily: 'เพื่อนหรือครอบครัว',
          coworkersClients: 'เพื่อนร่วมงานหรือลูกค้า',
          superiorFormal: 'ผู้บังคับบัญชาหรือข้อเสนอที่เป็นทางการ',
          closeColleagues: 'เพื่อนร่วมงานสนิท',
          professionalSetting: 'บริบทแบบมืออาชีพ',
          officialCorrespondence: 'จดหมายทางการ',
        },
      },
      pricing: {
        heading: 'ราคาที่เรียบง่ายและโปร่งใส',
        subheading: 'เริ่มต้นฟรี อัปเกรดเมื่อคุณต้องการพลังมากขึ้น ไม่มีค่าใช้จ่ายแอบแฝง',
        perMonth: '/ เดือน',
        starterName: 'เริ่มต้น',
        starterDesc: 'เหมาะสำหรับการทดลองใช้แพลตฟอร์ม',
        starterFeature1: '5,000 โทเคน / เดือน',
        starterFeature2: '3 โน้ต',
        starterFeature3: '10 คำ',
        starterFeature4: 'เข้าถึงประวัติ',
        getStarted: 'เริ่มต้นใช้งาน',
        proName: 'Pro',
        proDesc: 'สำหรับมืออาชีพที่ต้องการพลัง',
        popular: 'ยอดนิยม',
        proFeature1: '50,000 โทเคน / เดือน',
        proFeature2: 'โน้ตไม่จำกัด',
        proFeature3: 'บันทึกไม่จำกัด',
        proFeature4: 'การสนับสนุนแบบพิเศษ',
        proTrial: 'ทดลอง Pro',
      },
      cta: {
        heading: 'พร้อมที่จะทลายกำแพงภาษาแล้วหรือยัง?',
        subheading:
          'เข้าร่วมกับมืออาชีพนับพันที่ใช้ AI Workbench เพื่อสื่อสารข้ามภาษาอย่างไร้รอยต่อ',
        button: 'เริ่มต้นใช้งานฟรี',
      },
      footer: {
        tagline:
          'เครื่องมือแปลภาษายุคใหม่ที่ออกแบบมาเพื่อมืออาชีพ ทลายกำแพงภาษาอย่างไร้รอยต่อ',
        quickLinks: 'ลิงก์ด่วน',
        features: 'ฟีเจอร์',
        pricing: 'ราคา',
        rightsReserved: 'สงวนลิขสิทธิ์',
        poweredBy: 'ขับเคลื่อนโดย',
      },
      pricingPage: {
        backToWorkspace: 'กลับสู่พื้นที่ทำงาน',
        badge: 'ราคาที่เรียบง่ายและโปร่งใส',
        headingLine1: 'เลือกแพ็กเกจที่',
        headingLine2: 'เหมาะกับการทำงานของคุณ',
        subheading:
          'ปลดล็อกพลังเต็มรูปแบบของการแปลด้วย AI ที่เข้าใจบริบทและเครื่องมือจัดระเบียบระดับมืออาชีพ',
        perMonth: '/เดือน',
        mostPopular: 'ยอดนิยมที่สุด',
        freeName: 'ฟรี',
        freeDesc: 'เหมาะสำหรับผู้เริ่มต้นสำรวจ',
        freeFeature1: '1,000 โทเคน / เดือน',
        freeFeature2: 'ประวัติ 10 รายการล่าสุด',
        freeFeature3: 'โมเดล AI มาตรฐาน',
        freeFeature4: 'สมุดบันทึกพื้นฐาน (5 โน้ต)',
        freeFeature5: 'ใช้งานส่วนตัวเท่านั้น',
        freeCta: 'แพ็กเกจปัจจุบัน',
        proName: 'Pro',
        proDesc: 'เหมาะที่สุดสำหรับผู้ใช้ระดับสูงและมืออาชีพ',
        proFeature1: 'โทเคนไม่จำกัด',
        proFeature2: 'ประวัติการแปลทั้งหมด',
        proFeature3: 'โมเดล AI ระดับพรีเมียม (GPT-4o/Claude)',
        proFeature4: 'สมุดบันทึกและแท็กไม่จำกัด',
        proFeature5: 'ควบคุมโทนและสไตล์',
        proFeature6: 'บันทึกได้สูงสุด 1,000 คำ',
        proCta: 'อัปเกรดเป็น Pro',
        businessName: 'Business',
        businessDesc: 'ฟีเจอร์ขั้นสูงสำหรับทีม',
        businessFeature1: 'ทุกอย่างใน Pro',
        businessFeature2: 'การทำงานร่วมกันหลายผู้ใช้',
        businessFeature3: 'การเข้าถึง API (เบต้า)',
        businessFeature4: 'ฐานคำศัพท์เฉพาะทาง',
        businessFeature5: 'การสนับสนุนโดยเฉพาะ',
        businessFeature6: 'การแยกข้อมูลที่เน้นความเป็นส่วนตัว',
        businessCta: 'ติดต่อฝ่ายขาย',
        trustedBy: 'ได้รับความไว้วางใจจากมืออาชีพทั่วโลก',
        trustSsl: 'เข้ารหัส SSL',
        trustPrivacy: 'ความเป็นส่วนตัวในเครื่อง',
        trustAward: 'รางวัลการันตี',
        trustRating: 'คะแนน 4.9/5',
      },
    },
  },
};

export default landing;
